import React,{Component} from 'react';
import {createMarkup} from './Factory';

class AusstellungenDetails extends Component {
    constructor(props) {
		super(props);
		this.state = { 
		  gallery_url:(this.props.gallery_image[0])?this.props.gallery_image[0].image:'',
		  gallery_title:(this.props.gallery_image[0])?this.props.gallery_image[0].title:'',
		  gallery_alt:(this.props.gallery_image[0])?this.props.gallery_image[0].alt:'',
		  counter:0,
		  leftClass:'inactive',
		  rightClass:'active'
		}
		this.rotateNext = this.rotateNext.bind(this);
		this.rotatePrev = this.rotatePrev.bind(this);
	}
	rotateNext(){
		let counter = this.state.counter+1;
		let total = this.props.gallery_image.length;
		let dis = this;
		if(counter<total){
			let img = new Image();
			img.src = this.props.gallery_image[counter].image;
			img.onload = function() {
				setTimeout(function(){
					dis.setState({
						gallery_url:dis.props.gallery_image[counter].image,
						gallery_title:dis.props.gallery_image[counter].title,
						gallery_alt:dis.props.gallery_image[counter].alt,
						counter:counter,
						leftClass:''
					});
				},100);	
			}
		}else{ 
			this.setState({
				rightClass:'inactive'
			});
		}
	}
	rotatePrev(){
		let counter = this.state.counter-1;
		let dis = this;
		if(counter>=0){
			let img = new Image();
			img.src = this.props.gallery_image[counter].image;
			img.onload = function() {
				setTimeout(function(){
					dis.setState({
						gallery_url:dis.props.gallery_image[counter].image,
						gallery_title:dis.props.gallery_image[counter].title,
						gallery_alt:dis.props.gallery_image[counter].alt,
						counter:counter,
						rightClass:''
					});	
				},100);
			}	
		}else{ 
			this.setState({
				leftClass:'inactive'
			});
		}
		
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		if(this.props.gallery_image.length>0){
			this.props.gallery_image.map( (data,i) => {
				let img = new Image();
				img.src = data.image; 
				img.onload = function(){
					console.log(""); 
				}
				return null;
			});
		}
	}
	render(){				
		const { title,content,exhibition_start_date_final,exhibition_end_date_final,gallery_image} = this.props;
		let divStyle = {
				backgroundImage: 'url(' + this.state.gallery_url + ')',
				backgroundSize: 'auto 100%',
				maxWidth: '100%',
		}	
		return(
				<article className="col-md-8 article-full">
					 <h1 dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
					 <div className="times">
						<time dateTime={exhibition_start_date_final}>{exhibition_start_date_final} </time>
						<time dateTime={exhibition_end_date_final}>{'\u00A0'}– {exhibition_end_date_final}</time>
					 </div>
					 { (this.state.gallery_url) ? 
					 <div className="slider">
						<div className="images">
							<div title={this.state.gallery_title} className="fixed-ht-img" style={divStyle}>
								<img className="sr-only" src={this.state.gallery_url} alt={this.state.gallery_alt} title={this.state.gallery_title} />
							</div> 
						</div>
						{(gallery_image.length>1) ?
						<div className="slider-arrows">
							<i className={`icon-arrow-left ${this.state.leftClass}`} onClick={this.rotatePrev}></i>
							<i className={`icon-arrow-right ${this.state.rightClass}`} onClick={this.rotateNext}></i>
						</div>
						:null
						}
					</div> : null
					}
					<div className="md-txt article-txt content-section" dangerouslySetInnerHTML={createMarkup(content.rendered)}></div>
				</article>
		)
	}
}
export default AusstellungenDetails;


// WEBPACK FOOTER //
// ./src/components/AusstellungenDetails.js